import { ExternalLinkIcon } from "@radix-ui/react-icons";
import { Button, Flex } from "@radix-ui/themes";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { NavigationItems, NavigationItemId } from "@/shared/types/navigation";

interface QuickNavigationButtonsProps {
  exclude?: NavigationItemId[];
}

export const QuickNavigationButtons = ({
  exclude = [],
}: QuickNavigationButtonsProps) => {
  const { storeKey = "", orderId = "" } = useParams<{
    storeKey?: string;
    orderId?: string;
  }>();

  const [searchParams] = useSearchParams();
  const requestId = searchParams.get("request_id");

  const quickNavButtons = [
    {
      id: NavigationItems.LOD.id,
      label: NavigationItems.LOD.name,
      to: `/stores/${storeKey}/${orderId}`,
      visible: orderId && !exclude.includes(NavigationItems.LOD.id),
    },
    {
      id: NavigationItems.GCG.id,
      label: NavigationItems.GCG.name,
      to: `/stores/${storeKey}/gondola-change-groups/${orderId}${requestId ? `?request_id=${requestId}` : ""}`,
      visible: orderId && !exclude.includes(NavigationItems.GCG.id),
    },
    {
      id: NavigationItems.LAD.id,
      label: NavigationItems.LAD.name,
      to: `/stores/${storeKey}/dashboard/orders/${orderId}`,
      visible: orderId && !exclude.includes(NavigationItems.LAD.id),
    },
    {
      id: NavigationItems.LOD_ASSIGNMENT.id,
      label: NavigationItems.LOD_ASSIGNMENT.name,
      to: `/stores/${storeKey}/assignment?search=${orderId}`,
      visible: orderId && !exclude.includes(NavigationItems.LOD_ASSIGNMENT.id),
    },
  ].filter((button) => button.visible);

  if (quickNavButtons.length === 0) {
    return null;
  }

  return (
    <Flex gap="2">
      {quickNavButtons.map((button) => (
        <Link key={button.id} to={button.to} target="_blank">
          <Button variant="soft" size="1" color="gray">
            Open in {button.label} <ExternalLinkIcon />
          </Button>
        </Link>
      ))}
    </Flex>
  );
};
